import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ItemSummarySiteListService } from './item-summary-site-list.service';
import {HttpRequestErrorHandler} from '@rbaip/ui-component';
import {appConfig} from '../app.config';
import {Site} from '../domain/site';

@Injectable({
  providedIn: 'root'
})
export class ItemSummarySiteListServiceImpl extends ItemSummarySiteListService {

  constructor(private http: HttpClient) {
    super();
  }

  getSiteList(): void {
    const url = '/api/all-sites';
    this.http.get(url, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('getSiteList', []))
      )
      .subscribe(response => {
        this.data.sites = response as Site[];
        this.data.sites.sort((a, b) => a.id - b.id);
        this.siteListCallback.next(this.data.sites);
      });
  }

  public getSites(): Site[] {
    return this.data.sites;
  }
}
